<template>
    <div class="w-full h-full p-3">

        <div class="w-full mt-5 mb-3 flex justify-end items-center ">
            <div  @click="goToCreateView"
                class="flex justify-center items-center text-white space-x-1 bg-primary px-3 py-2 rounded-lg text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.75"
                    stroke="currentColor" class="w-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>


                <div>Admin</div>
            </div>

        </div>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg w-full ">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 ">
                <thead class="text-xs text-white  bg-primary rounded-t-xl  ">
                    <tr>
                        <th scope="col" class="px-6 py-3 rounded-tl-lg">Téléphone</th>
                        <th scope="col" class="px-6 py-3">E-mail</th>
                        <th scope="col" class="px-6 py-3">Etat</th>
                        <th scope="col" class="px-6 py-3">Date de creation</th>
                        <th scope="col" class="px-6 py-3  rounded-tr-lg">actions</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in adminsPagination.data" :key="index"
                        class="bg-white border-b   border-gray-200 hover:bg-gray-50 ">
                        <td class="px-6 py-4 font-medium">{{ row.phone }}</td>
                        <td class="px-6 py-4 font-medium">{{ row.email }}</td>
                        <td class="px-6 py-4">
                            <div v-if="row.active == 1"
                                class="bg-primary text-white px-3 py-2 text-center rounded  font-medium w-fit">Active
                            </div>
                            <div v-else
                                class="bg-gray-300 text-gray-800 px-3 py-2 text-center rounded font-medium w-fit">
                                Inactive
                            </div>

                        </td>
                        <td class="px-6 py-4 font-medium">{{ row.created_at.split('T')[0] }}</td>
                        <td class="px-6 py-4">
                            <div class="flex justify-start items-start ">

                                <div v-if="row.active != 1" @click="changeAdminStatus(row.id, 1)"
                                    class="flex justify-start items-center space-x-2  text-primary  rounded-lg w-fit hover:cursor-pointer hover:scale-110 transition duration-200 ">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="text-primary w-6">
                                        <path fill-rule="evenodd"
                                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                            clip-rule="evenodd" />
                                    </svg>

                                    <div class="font-medium">
                                        Activer</div>
                                </div>
                                <div v-else @click="changeAdminStatus(row.id, 0)"
                                    class="flex justify-start items-center space-x-2  text-red-400  rounded-lg w-fit hover:cursor-pointer hover:scale-110 transition duration-200 ">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="w-6 ">
                                        <path fill-rule="evenodd"
                                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    <div class="font-medium">
                                        Désactiver</div>

                                </div>



                            </div>

                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script setup>
import { changeAdminActiveStatus, getAdminList } from '@/api/admin';
import router from '@/router';
import { onMounted, ref, defineEmits } from 'vue';



const adminsPagination = ref([]);

const emit = defineEmits(['createAdmin'])

onMounted(async () => {
    try {
        let response = await getAdminList();
        console.log('response :>> ', response);

        adminsPagination.value = response.data.admins;

    } catch (error) {
        console.log('error :>> ', error);
    }
})


const changeAdminStatus = async (admin_id, activate) => {

    try {
        let response = await changeAdminActiveStatus({ admin_id, activate });
        if (response.data.success) {
            response = await getAdminList();
            adminsPagination.value = response.data.admins;
        }
    } catch (error) {
        console.log('error :>> ', error);
    }


}


const goToCreateView = () => {
    router.push('/admin/create');
}

</script>